export default __webpack_public_path__ + "static/media/profesional-o-influyente.edec1530.png";